import Quill from "quill";

const BlockEmbed = Quill.import("blots/block/embed");

class CustomImageBlot extends BlockEmbed {
  static blotName = "customImage";
  static tagName = "img";

  static create(value) {
    const node = super.create();
    const data = typeof value === "string" ? { url: value } : value;

    node.setAttribute("src", data.url || "");
    if (data.data_key) node.setAttribute("data-key", data.data_key);

    node.style.width = data.width || "200px";
    node.style.display = data.display || "block";
    node.style.float = data.float || "none";
    node.style.margin = data.margin || "0";

    return node;
  }

  static value(node) {
    return {
      url: node.getAttribute("src"),
      data_key: node.getAttribute("data-key"),
      width: node.style.width,
      display: node.style.display,
      float: node.style.float,
      margin: node.style.margin,
    };
  }
}

Quill.register(CustomImageBlot);

export default CustomImageBlot;
